<template>
  <div class="grid-main bg-purple ">
  <h2 style="float: left;">车辆管理列表</h2>
<!--    <el-tag-->
<!--      v-for="item in items"-->
<!--      :key="item.id"-->
<!--      :type="item.type"-->
<!--      @click="selectVehiclelist(item.id)"-->
<!--      :class="{active : item.id===curId}"-->
<!--      effect="light">-->
<!--      {{ item.label }}-->
<!--    </el-tag>-->

    <div class="point">
      <el-col :span="4" style="padding: 0;margin:10px; margin-left: 20px; width:auto; ">

        <!--                  <h2 style="float: left;">第</h2>-->

        <!--                  <el-input v-model="aquarter" type="text" placeholder="请输入季度"></el-input>-->
        <el-select v-model="curId" placeholder="请选择企业" style=" ;padding: 0px 0px 0px;width: 120px" >
          <el-option
            v-for="item in items"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>

      </el-col>
      <el-col :span="4" style="padding: 0; margin:10px ;width:120px; ">
                          <el-input v-model="vehicleLicenseTag" type="text" placeholder="请输入车牌号"></el-input>
      </el-col>
      <el-col :span="4" style="padding: 0;margin:10px ;width:120px; ">

                          <el-input v-model="vehicleHeadNum" type="text" placeholder="请输入车头码"></el-input>
      </el-col>
      <el-col :span="4" style="padding: 0;margin:10px ;width:120px; ">

        <el-input v-model="vehicleLockNum" type="text" placeholder="请输入车锁码"></el-input>
      </el-col>
      <el-col :span="4 " style="padding: 0; margin-right: 10px; width:auto; ">
        <el-button type="info" style="width: 139px; height: auto; color: #fff ; text-align: center; margin-top:0px!important" @click="selectVehiclelist(curId,1)">查询</el-button>
      </el-col>
    </div>


  <el-button type="primary" @click="dialogVehicle=true">添加车辆</el-button>
<!--    <el-upload-->
<!--      :action="vehicleReduce"-->
<!--      :show-file-list="false"-->
<!--      :on-success="onsuccess"-->
<!--      name="file"-->
<!--      class="elupload"-->
<!--    >-->
<!--      <el-button type="primary">车辆核减</el-button>-->
<!--    </el-upload>-->

    <el-upload
      :action="importVehicleForExcel"
      :show-file-list="false"
      :on-success="onsuccess"
      class="elupload"
      name="file">
      <el-button type="primary">车辆批量导入</el-button>
    </el-upload>
<!--    <el-button type="primary" @click="download()" style="margin-right: 10px">示例下载</el-button>-->
    <div class="table-box">
    <el-table
      :data="VehicleList.list"
      height="550"
      border
      style="width: 100%;">
      <!-- <el-table-column
              prop="vehicleNum"
              label="单车编号"
              width="180">
      </el-table-column> -->
      <el-table-column
        prop="vehicleLicenseTag"
        label="车牌号"
        width="180">
      </el-table-column>
      <el-table-column
        prop="vehicleHeadNum"
        label="车头码">
      </el-table-column>
      <el-table-column
        prop="vehicleLockNum"
        label="车锁码">
      </el-table-column>
<!--      <el-table-column-->
<!--        prop="vehicleModel"-->
<!--        label="车辆型号">-->
<!--      </el-table-column>-->
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button
          	type="success"
            size="mini"
            @click="openscoreType(scope.row.id)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="openDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
    	v-if="VehicleList.VehicleListtotal>10"
      background
      layout="prev, pager, next"
      :page-size="VehicleList.VehicleListtpageSize"
      @current-change="setVehicleListlist"
      :total="VehicleList.VehicleListtotal">

    </el-pagination>
  </div>

  <el-dialog  :visible.sync="dialogVehicle" :before-close="dialogrolVehicleByIdclose">

    <el-form ref="form"  label-width="200px">

      <el-form-item label="季度" >
        <el-col :span="9" style="width: 160px;">
          <el-date-picker
            v-model="VehicleAdds.year"
            type="year"
            style="width: 160px"
            format="yyyy"
            value-format="yyyy"
            :picker-options="pickerOptionsadd"
            @change="pickerChangeFn"
            placeholder="请选择年份">
          </el-date-picker>
        </el-col>
        <el-col class="line" :span="2" style="line-height: 40px;">-</el-col>
        <el-col :span="9">
          <el-select v-model="VehicleAdds.quarter" placeholder="请选择季度" style="float: left ;padding: 0px 0px 0px;" :clearable ="true">

            <el-option
              v-for="item in quarters"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>


        </el-col>
      </el-form-item >
      <el-form-item label="运营商">
        <el-select v-model="VehicleAdds.curId" placeholder="请选择" style="float: left;">
          <el-option
            v-for="item in items"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="车辆型号">-->
<!--        <el-input v-model="VehicleAdds.vehicleModel" type="text" placeholder="请输入车辆型号"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="车牌号">
        <el-input v-model="VehicleAdds.vehicleLicenseTag" type="text" placeholder="请输入车牌号"></el-input>
      </el-form-item>
      <el-form-item label="车头码">
        <el-input v-model="VehicleAdds.vehicleHeadNum" type="text" placeholder="请输入车头码"></el-input>
      </el-form-item>
      <el-form-item label="车锁码">
        <el-input v-model="VehicleAdds.vehicleLockNum" type="text" placeholder="请输入车锁码"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="VehicleAdd()">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>



  <el-dialog  :visible.sync="dialogupdatVehicleById" :before-close="dialogrolVehicleByIdclose">
    <el-form ref="form"  label-width="200px">
      <el-form-item label="季度">
        <el-col :span="9">
          <el-date-picker
            v-model="updatVehicleBy.year"
            type="year"
            style="width: 160px"
            format="yyyy"
            value-format="yyyy"
            :picker-options="pickerOptionsEnd"
            @change="pickerChangeFn"
            placeholder="请选择年份">
          </el-date-picker>
        </el-col>
        <el-col class="line" :span="2" style="line-height: 40px;">-</el-col>
        <el-col :span="9">
          <el-select v-model="updatVehicleBy.quarter" placeholder="请选择季度" style="float: left ;padding: 0px 0px 0px;" :clearable ="true">

            <el-option
              v-for="item in quarters"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>


        </el-col>
      </el-form-item >
      <el-form-item label="运营商">
        <el-select v-model="updatVehicleBy.curId" placeholder="请选择" style="float: left;">
          <el-option
            v-for="item in items"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="车辆型号">-->
<!--        <el-input v-model="updatVehicleBy.vehicleModel" type="text" placeholder="请输入车辆型号"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="车牌号">
        <el-input v-model="updatVehicleBy.vehicleLicenseTag" type="text" placeholder="请输入车牌号"></el-input>
      </el-form-item>
      <el-form-item label="车头码">
        <el-input v-model="updatVehicleBy.vehicleHeadNum" type="text" placeholder="请输入车头码"></el-input>
      </el-form-item>
      <el-form-item label="车锁码">
        <el-input v-model="updatVehicleBy.vehicleLockNum" type="text" placeholder="请输入车锁码"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="updateVehicle()">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>

  </div>

</template>

<script>
export default {
  name: "Setgps",
  data(){
    return {

      items: [
        { id:1,
          name:'美团',
          type: 'success',
          code:'MT'
        },
        {   id:2,
          name:'哈啰',
          type: 'info',
          code:'HB'
        },
        {
          id:3,
          name:'青桔',
          type: 'danger',
          code:'DD'
        },
      ],
      pickerOptionsadd: {
        disabledDate: time => {
          let beginDateVal = this.VehicleAdds.year
          // if (beginDateVal) {
          return (
            time.getTime() <
            new Date(beginDateVal).getTime() - 86400000 || time.getTime() > Date.now()
          )
          // }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.updatVehicleBy.year
          // if (beginDateVal) {
          return (
            time.getTime() <
            new Date(beginDateVal).getTime() - 86400000 || time.getTime() > Date.now()
          )
          // }
        }
      },
      importVehicleForExcel:'/api/vehicle/importVehicleForExcel',
      vehicleReduce:'/api/vehicle/vehicleReduce',
      //车辆管理
      VehicleList:{
        list:[],
        VehicleListtpage:1,
        VehicleListtotal:0,
        VehicleListtpageSize:10
      },

      VehicleAdds:{
        year:'',
        quarter:'',
        curId:'',
       // vehicleModel:'',
        vehicleLicenseTag:'',
        vehicleHeadNum:'',
        vehicleLockNum:'',
      },
      dialogVehicle:false,

      //修改车辆管理
      updatVehicleBy:{
        year:'',
        quarter:'',
        curId:'',
        //vehicleModel:'',
        vehicleLicenseTag:'',
        vehicleHeadNum:'',
        vehicleLockNum:'',
      },
      dialogupdatVehicleById:false,

      curId:1,
      vehicleLicenseTag:'',
      vehicleHeadNum:'',
      vehicleLockNum:'',

      quarters: [
        {   id:1,
          name: '第一季度',

        },
        {   id:2,
          name: '第二季度',

        },
        {
          id:3,
          name: '第三季度',
        },
        {
          id:4,
          name: '第四季度',
        },
      ],

    }
  },
  watch: {
    curId:function (value) {
      this.selectVehiclelist(value,1);
    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
    this.selectVehiclelist(1,1);

  },
  methods: {
    // download(){
    //   location.href="../../assets/anli.xlsx"
    // },
    dialogrolVehicleByIdclose(){
      this.updatVehicleBy = {
        year:'',
        quarter:'',
        curId:'',
      //  vehicleModel:'',
        vehicleLicenseTag:'',
        vehicleHeadNum:'',
        vehicleLockNum:'',
      };
      this.dialogupdatVehicleById =false;
      this.VehicleAdds = {
        year:'',
        quarter:'',
        curId:'',
       // vehicleModel:'',
        vehicleLicenseTag:'',
        vehicleHeadNum:'',
        vehicleLockNum:'',
      };
      this.dialogVehicle=false;

    },
    onsuccess(res, file, fileList){
      let that = this;

      if(res.code==200){
        that.$message({
          message: '上传成功',
          type: 'success'
        });
        window.setTimeout(() => {
          location.reload();
        }, 1000);
      }else{
        that.$message.error('上传失败');
      }
    },
    selectVehiclelist(index,page){
      let that = this;
      this.curId =index;
      let selectVehicledata = {
        page:page,
        pageSize:this.VehicleList.VehicleListtpageSize,
        operatorNum:this.curId,
        vehicleLicenseTag:this.vehicleLicenseTag,
        vehicleHeadNum:this.vehicleHeadNum,
        vehicleLockNum:this.vehicleLockNum,
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/vehicle/selectVehicle',selectVehicledata)
        .then(function (res) {

          if(res.data.code==200){
            that.VehicleList.list = res.data.data.list;
            that.VehicleList.VehicleListtotal = res.data.data.total;
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    setVehicleListlist(VehicleListtpage){
      this.VehicleList.VehicleListtpage = VehicleListtpage;
      this.selectVehiclelist(this.curId,VehicleListtpage);
    },

//新增车辆管理
    VehicleAdd(){
      let that = this;
      if (that.VehicleAdds.year == '') {
        that.$message.error('请选择年份');
        return false;
      }
      if (that.VehicleAdds.quarter == '') {
        that.$message.error('请选择季度');
        return false;
      }
      // if (that.VehicleAdds.vehicleModel == '') {
      //   that.$message.error('请输入车辆类型');
      //   return false;
      // }
      if (that.VehicleAdds.curId == '') {
        that.$message.error('请选择运营商');
        return false;
      }
      if (that.VehicleAdds.vehicleLicenseTag == '') {
        that.$message.error('请输入车牌号');
        return false;
      }
      if (that.VehicleAdds.vehicleHeadNum == '') {
        that.$message.error('请输入车头码');
        return false;
      }
      if (that.VehicleAdds.vehicleLockNum == '') {
        that.$message.error('请输入车锁码');
        return false;
      }
      let vehicleAddsa = {
        year:that.VehicleAdds.year,
        quarter:that.VehicleAdds.quarter,
        operatorNum:that.VehicleAdds.curId,
        //vehicleModel:that.VehicleAdds.vehicleModel,
        vehicleLicenseTag:that.VehicleAdds.vehicleLicenseTag,
        vehicleHeadNum:that.VehicleAdds.vehicleHeadNum,
        vehicleLockNum:that.VehicleAdds.vehicleLockNum,
      }
      this.$axios
        .post('/api/vehicle/vehicleAdd', vehicleAddsa)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("新增车辆管理信息失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '新增车辆管理信息成功',
              type: 'success'
            });
            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });


    },
//编辑车辆管理

    selectVehicleById(){

      let that = this;

      let selectVehicleByIddata = {
        id:that.VehicleById
      }
      this.$axios
        .post('/api/vehicle/selectVehicleById', selectVehicleByIddata)
        .then(function (res) {
         // that.updatVehicleBy.vehicleModel=res.data.data.vehicleModel;
          that.updatVehicleBy.year=''+res.data.data.year;
          that.updatVehicleBy.quarter=res.data.data.quarter;
          that.updatVehicleBy.curId=Number(res.data.data.operatorNum);
          that.updatVehicleBy.vehicleLicenseTag=res.data.data.vehicleLicenseTag;
          that.updatVehicleBy.vehicleHeadNum=res.data.data.vehicleHeadNum;
          that.updatVehicleBy.vehicleLockNum=res.data.data.vehicleLockNum;


        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    openscoreType(VehicleById){

      this.VehicleById = VehicleById;
      this.selectVehicleById();
      console.log(this.updatVehicleBy)
      window.setTimeout(() => {
        this.dialogupdatVehicleById = true;
      },100)



    },
//修改车辆管理
    updateVehicle(){
      let that = this;
      if (that.updatVehicleBy.year == '') {
        that.$message.error('请选择年份');
        return false;
      }
      if (that.updatVehicleBy.quarter == '') {
        that.$message.error('请选择季度');
        return false;
      }
      if (that.updatVehicleBy.curId == '') {
        that.$message.error('请选择运营商');
        return false;
      }
      if (that.updatVehicleBy.vehicleLicenseTag == '') {
        that.$message.error('请输入车牌号');
        return false;
      }
      if (that.updatVehicleBy.vehicleHeadNum == '') {
        that.$message.error('请输入车头码');
        return false;
      }
      if (that.updatVehicleBy.vehicleLockNum == '') {
        that.$message.error('请输入车锁码');
        return false;
      }
      let updateVehicledates = {
        id:that.VehicleById,
        year:that.updatVehicleBy.year,
        quarter:that.updatVehicleBy.quarter,
        //vehicleModel:that.updatVehicleBy.vehicleModel,
        operatorNum:that.updatVehicleBy.curId,
        vehicleLicenseTag:that.updatVehicleBy.vehicleLicenseTag,
        vehicleHeadNum:that.updatVehicleBy.vehicleHeadNum,
        vehicleLockNum:that.updatVehicleBy.vehicleLockNum,
      }
      this.$axios
        .post('/api/vehicle/updateVehicle', updateVehicledates)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("修改车辆管理失败"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '修改车辆管理成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);

          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },


    openDelete(vehicleIds) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DeleteVehicle(vehicleIds)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

//删除考核项分类
    DeleteVehicle(vehicleIds){
      let that = this;
      let vehicleIdsdeta = {
        vehicleIds:[]
      }
      vehicleIdsdeta.vehicleIds.push(vehicleIds);
      this.$axios
        .post('/api/vehicle/batchDeleteVehicle',vehicleIdsdeta)
        .then(function (res) {

          if(res.data.code==200){
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },



  },

}
</script>

<style scoped>
/*/deep/ .el-button--primary {
  width: auto!important;
  margin-bottom: 30px;
  margin-top: 0.83em!important;
  float: right;
}*/
/deep/ .elupload .el-upload {
  border: 0px dashed #d9d9d9;
  border-radius: 0%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  float: right;
  margin-right: 10px;
}
.point {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  line-height: 0px;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
/deep/ .el-button--info{
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/Setgps.vue